<template>
  <div class="unloading-order-page-stats">
    <div class="info-board">
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[OrderCreated] }} Orders</span>
          <span class="sub-title">{{ OrderCreated }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[OrderProcessing] }} Orders</span>
          <span class="sub-title">{{ OrderProcessing }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[OrderCompleted] }} Orders</span>
          <span class="sub-title">{{ OrderCompleted }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryOrders } from '@/api/order'
import {
  OrderCompleted,
  OrderCreated,
  OrderDeleted,
  OrderProcessing,
  UnloadingOrder
} from '@/core/models/order'
export default {
  name: 'UnloadingOrderPageStats',
  props: {
    timeRange: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      UnloadingOrder,
      OrderCompleted,
      OrderCreated,
      OrderDeleted,
      OrderProcessing,
      counts: {
        [OrderCreated]: 999,
        [OrderProcessing]: 999,
        [OrderCompleted]: 999,
        [OrderDeleted]: 999
      }
    }
  },
  watch: {
    timeRange: {
      handler() {
        this.countDifferentStatus()
      },
      immediate: true
    }
  },
  methods: {
    countDifferentStatus() {
      this.countOrders(OrderCreated)
      this.countOrders(OrderProcessing)
      this.countOrders(OrderCompleted)
      this.countOrders(OrderDeleted)
    },
    countOrders(status) {
      queryOrders({
        typeList: [UnloadingOrder],
        statusList: [status],
        createdTimeRange: this.timeRange,
        size: 0
      }).then(res => {
        this.counts[status] = res.total
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  gap: 20px;
  flex-wrap: wrap;

  .stats-info-card {
    pointer-events: none;
    min-width: 160px !important;

    .info-card-left {
      .title {
        font-size: 30px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald light', sans-serif;
      }
    }
  }

  @extend .global-margin;
  @extend .f-r-vc;
}
</style>
